import { Drfq } from '@paradigm/features/src/unified-rfqs/entities/drfq/domain';
import { processLeg } from '@paradigm/features/src/unified-rfqs/ui/drfq/legs-table-functions';
import BaseLegsTable from '#/components/UnifiedRfqs/components/LegsTable';
import { NEGATIVE_SIGN } from '@paradigm/utils/src/enhanceNegativeSign';
import useDrfqBbo from '@paradigm/features/src/unified-rfqs/contexts/use-drfq-bbo';
import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';
import { LegInfoCard } from '#/components/UnifiedRfqs/components/MobileLegsTable';

export default function DrfqDetailsLegsTable({ drfq }: { drfq: Drfq }) {
  const isMobile = useIsMobile();
  const { legs } = drfq;
  const processLegs = legs.map(processLeg);
  const bbo = useDrfqBbo(drfq.id);
  const markPrices = bbo?.legs;

  return isMobile ? (
    <>
      {processLegs.map((leg, index) => (
        <LegInfoCard
          key={leg.index}
          markPrice={markPrices ? markPrices[index]?.mark_price : NEGATIVE_SIGN}
          legPricingEnabled={false}
          legPrice={undefined}
          isTwoWay={false}
          leg={leg}
        />
      ))}
    </>
  ) : (
    <BaseLegsTable side="BUY" legs={processLegs} />
  );
}
